import React from 'react';
import {Path} from "../components/svg/components/path";
import {useThemeColor} from "../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../app/consts/colors";

export const NavigationArrowForward = ({style = { width: 24, height: 24, fill: useThemeColor(COLORS.blackPrimary)}, ...rest}) => {
  return <svg focusable="false"  viewBox={`0 0 24 24`} aria-hidden="true" {...style} {...rest}>
    <Path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
  </svg>
}
